export class StructuredAddress {
  constructor(
    public streetAddress: string,
    public postalCode: string,
    public countryCode: string,
    public city: string
  ) {}
}
